<template>
  <div class="notice-box" :class="`notice-box--${severity}`">
    <i :class="iconClass" class="notice-icon" />
    <span class="notice-content">{{ message }}</span>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, computed, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import type { NoticeSeverity } from '@/composables/template-editor/useShopifyPasswordNotice';

export default defineComponent({
  name: 'NoticeBox',

  props: {
    severity: {
      type: String as PropType<NoticeSeverity>,
      default: 'info',
    },
    i18nKey: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const iconClass = computed(() => {
      switch (props.severity) {
        case 'warning': return 'fas fa-exclamation-circle';
        case 'danger': return 'fas fa-times-circle';
        case 'info':
        default: return 'fas fa-info-circle';
      }
    });

    const message = computed(() => t(props.i18nKey));

    return { iconClass, message };
  },
});
</script>

<style scoped lang="scss">
.notice-box {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.625rem;
  margin: 0.5rem 0;
  font-size: 0.75rem;
  line-height: 1.4;
  border: 1px solid transparent;
  border-radius: 4px;

  .notice-icon {
    font-size: 0.75rem;
    margin-top: 0.125rem;
    flex-shrink: 0;
  }

  .notice-content {
    flex: 1;
  }

  &--info {
    color: #1e40af;
    background: #eff6ff;
    border-color: #bfdbfe;

    .notice-icon { color: #3b82f6; }
  }

  &--warning {
    color: #b45309;
    background: #fffbeb;
    border-color: #fde68a;

    .notice-icon { color: #f59e0b; }
  }

  &--danger {
    color: #b91c1c;
    background: #fef2f2;
    border-color: #fecaca;

    .notice-icon { color: #ef4444; }
  }
}
</style>
